export default "__VITE_ASSET__aOBCBaZO__"